import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAGzrCW7tDNgQIWWoNLyA7U5k6aMDgctrI",
  authDomain: "shelfspace2.firebaseapp.com",
  projectId: "shelfspace2",
  storageBucket: "shelfspace2.firebasestorage.app",
  messagingSenderId: "620712492120",
  appId: "1:620712492120:web:d6fe882668040a1c435e2d"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;